import { useCallback, useEffect, useState } from 'react';

import styled from '@emotion/styled';

import { zIndex } from '../../../../shared/styles';
import COLOR from '../../../../shared/constant/colorset';

import { useAppSelector } from '../../../../shared/store';

import OpenButton from '../components/buy-footer/OpenButton';
import BuyFooter from '../components/buy-footer/BuyFooter';
import { amplitudeService, ScreenName } from '../../../../shared/amplitude';
import {
  ViewProductSelection,
} from '../../../../shared/amplitude/events/product/ViewProductSelection';
import Alert from '../../../../shared/components/Alert/Alert';
import useProductBuy from '../../hooks/useProductBuy';
import { getFusionQueryId } from '../../shared/utils/productDetailEvent';

const Container = styled.div`
  position: fixed;
  z-index: ${zIndex.productBuyFooter};
  left: 0;
  bottom: 0;
  width: 100%;
  min-height: 20px;
  background-color: ${COLOR.kurlyWhite};
  border-top: 2px solid ${COLOR.kurlyPurple};
`;

const BuyFooterWrapper = styled.div`
  position: relative;
  width: 900px;
  margin: 0 auto;
  font-family: 'Noto Sans';
`;

interface Props {
  isDisplay: boolean;
}

export default function BuyFooterContainer({ isDisplay }: Props) {
  const { isGuest } = useAppSelector(({ auth }) => auth);
  const { queryId } = useAppSelector(({ productList }) => productList);
  const productDetailState = useAppSelector(({ productDetail }) => productDetail);

  const {
    defaultContentId, no, dealProducts, contentType, isDirectOrder, isSoldOut, isPurchaseStatus,
    isExpectedPoint, canRestockNotify, discountedPrice, directOrderType,
  } = productDetailState;

  const loggedIn = !isGuest;

  const [openSection, setOpenSection] = useState(false);

  const { buyText, buyProduct } = useProductBuy({
    isDirectOrder, isSoldOut, isPurchaseStatus,
  });

  const handleClickOpenSection = useCallback(() => {
    if (!openSection) {
      amplitudeService
        .logEvent(new ViewProductSelection({
          productDetailState,
          defaultContentId,
          fusionQueryId: getFusionQueryId(queryId),
        }));
      amplitudeService.setScreenName(ScreenName.PRODUCT_SELECTION);
    }

    setOpenSection(!openSection);
  }, [defaultContentId, openSection, productDetailState]);

  const onClickCartButton = useCallback(async () => {
    try {
      await buyProduct();
    } catch (error) {
      Alert({
        title: '알림',
        text: error.message,
      });
    }
  }, [buyProduct, defaultContentId, productDetailState]);

  useEffect(() => {
    if (!isDisplay) {
      amplitudeService.setScreenName(ScreenName.PRODUCT_DETAIL_DESCRIPTION);
      setOpenSection(false);
    }
  }, [isDisplay]);

  if (!isDisplay) {
    return null;
  }

  return (
    <Container>
      <BuyFooterWrapper>
        <OpenButton
          openSection={openSection}
          onClick={handleClickOpenSection}
        />
        {openSection && (
          <BuyFooter
            loggedIn={loggedIn}
            buyText={buyText}
            onClickCartButton={onClickCartButton}
            productNo={no}
            dealProducts={dealProducts}
            contentType={contentType}
            isSoldOut={isSoldOut}
            isPurchaseStatus={isPurchaseStatus}
            canRestockNotify={canRestockNotify}
            isDiscountProduct={!!discountedPrice}
            isExpectedPoint={isExpectedPoint}
            directOrderType={directOrderType}
          />
        )}
      </BuyFooterWrapper>
    </Container>
  );
}
